import React from "react";
import { CgClipboard, CgCopy } from "react-icons/cg";
import classes from './CopyParamsButton.module.css'
import 'colors.css'

interface Props {
    copyParamsInBuffer?: (params: any) => void,
    pastParamsInBuffer?: (params: any) => void,
}

const CopyParamsButton = ({ copyParamsInBuffer, pastParamsInBuffer }: Props) => {
    return (
        <div className={classes.container}>
            <button type="button" className={classes.iconContainer} onClick={pastParamsInBuffer} aria-label="Paste parameters">
                <CgClipboard />
                Paste
            </button>
            <span className={classes.paramsText}>Params</span>
            <button type="button" className={classes.iconContainer} onClick={copyParamsInBuffer} aria-label="Copy parameters">
                <CgCopy />
                Copy
            </button>
        </div>
    );
}

export default CopyParamsButton;